module.exports = new __parcel__URL__("neutral-mask.7cced194.svg").toString();